import { __assign } from "tslib";
import { createIntlLite, } from '@concur/intl-runtime';
import React from 'react';
import { IntlContext } from '../useIntl';
/**
 * React provider for intl message formatting functions
 */
export function IntlProviderLite(props) {
    var _a = props.messages, messages = _a === void 0 ? {} : _a, localeData = props.localeData, customFormatters = props.customFormatters;
    var intl = React.useMemo(function () {
        var lite = createIntlLite(__assign({ messages: messages }, localeData), customFormatters);
        return __assign(__assign({}, lite), { formatCurrency: notImplemented('formatCurrency'), formatCurrencyToParts: notImplemented('formatCurrency'), formatNumber: notImplemented('formatNumber'), formatDate: notImplemented('formatDate'), moment: null, numeral: null, 
            // Export these to remain consistent with nui-intl
            formattedCurrency: notImplemented('formattedCurrency'), formattedNumber: notImplemented('formattedNumber'), formattedDate: notImplemented('formattedDate') });
    }, [messages, localeData, customFormatters]);
    return React.createElement(IntlContext.Provider, { value: intl }, props.children);
}
function notImplemented(method) {
    return function () {
        throw new Error([
            "[NUI Intl Runtime: ".concat(method, "]: You are consuming a function/component of NUI Intl Library "),
            'that is exposed only through <IntlProvider />',
            'however, you are accesing it through <IntlProviderLite />.',
            '',
        ].join('\n'));
    };
}
